import { useEffect, useState } from "react";
import PaymentForm from "../components/PaymentForm";
import Header from "../components/layout/Header";
import CarritoCompras from "../components/CarritoCompras";
import { useProductos } from "../hooks/useProductos";
import { useParams } from "react-router-dom";

const Confirmation = () => {
    const [openCart, setOpenCart] = useState(false);

    const { orden, getOrden, formatoCOP } = useProductos();
    const { norden } = useParams();

    useEffect(() => {
        if (norden) {
            getOrden(norden);
        }
    }, []);


    return (
        <>
            <div className="wrapper" style={{ maxWidth: "100%", background: "#000000" }}>
                <Header setOpenCart={setOpenCart} openCart={openCart} />
                <CarritoCompras setOpenCart={setOpenCart} openCart={openCart} />
                <div className="wrapper" style={{ margin: "100px auto", background: "#000000" }}>
                    <div className="container-preview" style={{ flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%" }}>
                        <h1>Total a pagar {formatoCOP.format(orden?.total)}</h1>
                        {orden?.isPickup && (
                            <div style={{ 
                                backgroundColor: "#333", 
                                padding: "20px", 
                                borderRadius: "8px", 
                                margin: "20px 0", 
                                textAlign: "center",
                                fontWeight: "bold",
                                color: "#ffdd00",
                                border: "2px solid #ffdd00",
                                maxWidth: "500px",
                                width: "100%"
                            }}>
                                <h3 style={{margin: "0 0 10px 0"}}>RECOGIDA EN TIENDA</h3>
                                <p style={{color: "#fff", fontWeight: "normal", margin: "0"}}>
                                    Has seleccionado recoger tu pedido en nuestra tienda física. 
                                    Después de realizar el pago, guarda tu número de pedido para presentarlo al recoger tu producto.
                                </p>
                            </div>
                        )}
                        <PaymentForm />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Confirmation;